// Enumerations
import { RoutesCommonEnumeration } from 'enumerations/routes.common.enumeration';

export const ROUTER_PROPS = {
  basename: `/${RoutesCommonEnumeration.BASE_PATH}`,
};
